/* eslint-disable semi */
/* eslint-disable comma-dangle */
/* eslint-disable quotes */
import axios from "axios";

const request = axios.create({
  // baseURL: process.env.VUE_APP_BUILD_URL,
  // baseURL: "http://localhost:8080/api/admin",
  // baseURL: "http://219.248.246.69:9000/api/admin",
  baseURL: "https://nonpayment.songpagongdanpark2.or.kr/api/admin",
  changeOrigin: true,
  // headers: {
  //   Authorization: `Bearer ${localStorage.getItem("accessToken")}`
  // },
  timeout: 0,
});

request.interceptors.request.use((config) => {
  if (!config.headers["Authorization"]) {
    if (
      localStorage.getItem("accessToken") &&
      localStorage.getItem("accessToken").length > 0
    ) {
      config.headers["Authorization"] = `Bearer ${localStorage.getItem(
        "accessToken"
      )}`;
    }
  }

  config.headers["Access-Control-Allow-Origin"] = "*"; // CORS 설정(모든 리소스 허용)
  return config;
});

export default request;
